import React, { useState, useEffect } from 'react';
import { useSearchParams, useLocation } from 'react-router-dom';

import { MESSAGE_MODALS } from '../../context/custom/MessageModalContext';
import { ALERT_TYPE, OPERATION_MODE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { APIS } from '../../config/apis';
import { ServerRequest } from '../../utils/apiweb';
import { TableCustom, SectionHeading, FooterButtonVolver } from '../../components/common';
import TipoRelacionCertificadoApremioPersonaModal from '../../components/controls/TipoRelacionCertificadoApremioPersonaModal';
import { useEntidad } from '../../components/hooks/useEntidad';
import { useManagedContext } from '../../components/hooks';
import { standardRequest } from '../../utils/requests';
import { PERMISSIONS } from '../../consts/permissions';

function TipoRelacionesCertificadoApremioPersonaView() {
    const { setIsLoading, showMessageModal } = useManagedContext()
    const location = useLocation()
    const previousFilters = location.state?.filters

    //hooks
    const [state, setState] = useState({
        showForm: false,
        modeFormEdit: false,
        rowId: 0,
        list: []
    });

    const mount = () => {

        SearchTipoRelacionesCertificadoApremioPersona();
        
        const unmount = () => {}
        return unmount;
    }
    useEffect(mount, []);

    const [search] = useSearchParams();
    const isViewOnly = search.get('mode') === OPERATION_MODE.VIEW;
    const allowEditActions = !isViewOnly;

    const [, getRowEntidad] = useEntidad({
        entidades: ['TipoControlador'],
        onLoaded: (entidades, isSuccess, error) => {
          if (isSuccess) {
            setState(prevState => ({...prevState}));
          }
          else {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
          }
        },
        memo: {
          key: 'TipoControlador',
          timeout: 0
        }
    });

    //definiciones
    const getTipoControlador = (id) => {
        const row = getRowEntidad('TipoControlador', id);
        return (row) ? row.nombre : '';
     }
    
    const tableColumns = [
        { Header: 'Código', accessor: 'codigo', width: '20%' },
        { Header: 'Descripción', accessor: 'descripcion', width: '50%' },
        { Header: 'Tipo de controlador', Cell: (data) => getTipoControlador(data.value), accessor: 'idTipoControlador', width: '20%' },
    ];

    //handles
    const avmr = {
        onAdd: () => {
            setState(prevState => ({...prevState, showForm: true, modeFormEdit: true, rowId: 0}))
        },
        onView: ({ id }) => {
            setState(prevState => ({...prevState, showForm: true, modeFormEdit: false, rowId: parseInt(id)}))
        },
        onModify: ({ id }) => {
            setState(prevState => ({...prevState, showForm: true, modeFormEdit: true, rowId: parseInt(id)}))
        },
        onRemove: ({ id }) => {
            const relacion = state.list.find(x => x.id === id)
            showMessageModal({
                ...MESSAGE_MODALS.BORRAR,
                message: `¿Está seguro de borrar el tipo de relación ${relacion.descripcion}?`,
                onConfirm: () => {
                    setIsLoading(true)
                    standardRequest(REQUEST_METHOD.DELETE, `${APIS.URLS.TIPO_RELACION_CERTIFICADO_APREMIO_PERSONA}/${id}`)
                    .then(() => SearchTipoRelacionesCertificadoApremioPersona())
                    .catch(() => {})
                    .then(() => setIsLoading(false))
                }
            })
        }
    }

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
          const message = error.message;
          ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
          setIsLoading(false)
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setIsLoading(false)
        });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setIsLoading(false)
    }

    //funciones
    function SearchTipoRelacionesCertificadoApremioPersona() {
        setIsLoading(true)
        setState(prev => ({ ...prev, list: [] }))

        const callbackSuccess = (response) => {
            response.json()
            .then((data) => {
                data.forEach(x => {
                    if (x.fechaCreacion) x.fechaCreacion = new Date(x.fechaCreacion);
                });
                setIsLoading(false)
                setState(prev => ({ ...prev, list: data }))
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setIsLoading(false)
            });
        };


        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.TIPO_RELACION_CERTIFICADO_APREMIO_PERSONA,
            null,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    return (
    <>
        {state.showForm && 
            <TipoRelacionCertificadoApremioPersonaModal
                id={state.rowId}
                disabled={!state.modeFormEdit}
                onDismiss={() => {
                    setState(prevState => {
                        return {...prevState, showForm: false};
                    });
                }}
                onConfirm={(id) => {
                    setState(prevState => {
                        return {...prevState, showForm: false, rowId: 0};
                    });
                    SearchTipoRelacionesCertificadoApremioPersona();
                }}
            />
        }

        <SectionHeading
            titles={[
                { title: 'Entidades' },
                { title: 'Administración de listas', url: '/entidades' },
                { title: 'Tipos de relación certificado apremio persona' }
            ]}
        />

        <section className='section-accordion'>

            <div className="m-top-20">

                <TableCustom
                    className={'TableCustomBase'}
                    columns={tableColumns}
                    data={state.list}
                    avmr={avmr}
                    editCode={PERMISSIONS.LISTAS_INGRESOS_PUBLICOS_EDIT}
                    disabled={!allowEditActions}
                />

            </div>

        </section>
        
        <footer className='footer footer-action'>
            <div className='footer-action-container'>
                <FooterButtonVolver filters={previousFilters} to="/entidades" />
            </div>
        </footer>

    </>
    )
}

export default TipoRelacionesCertificadoApremioPersonaView;
